<div class="dl-node-dom-ballon"
     [style.left]="dialoogLeft"
     (pointerenter)="opHoverIn()"
     (pointerleave)="opHoverOut()">
    <ng-content></ng-content>
</div>
